<template>
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.5 3C4.11929 3 3 4.11929 3 5.5V18.5C3 19.8807 4.11929 21 5.5 21H18.5C19.8807 21 21 19.8807 21 18.5V5.5C21 4.11929 19.8807 3 18.5 3H5.5ZM16.5303 11.7204C16.7966 11.9866 16.8208 12.4033 16.6029 12.6969L16.5303 12.781L12.5295 16.7819C12.2632 17.0482 11.8465 17.0723 11.5529 16.8544L11.4687 16.7818L7.46875 12.7802C7.17591 12.4873 7.176 12.0124 7.46895 11.7196C7.73527 11.4534 8.15193 11.4292 8.4455 11.6471L8.52961 11.7198L11.2503 14.4417L11.25 7.75C11.25 7.3703 11.5322 7.05651 11.8982 7.00685L12 7C12.3797 7 12.6935 7.28215 12.7432 7.64823L12.75 7.75L12.7503 14.4397L15.4697 11.7204C15.7359 11.4541 16.1526 11.4299 16.4462 11.6478L16.5303 11.7204Z"/>
  </svg>
</template>

<script>
export default {
name: "IconArrowDownSquare"
}
</script>

<style scoped>

</style>